var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup3085(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3085",
    "data-name": "Group 3085",
    transform: "translate(-21508 23788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3078",
    "data-name": "Group 3078",
    transform: "translate(21507.545 -23787.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    transform: "translate(0.455 -0.254)",
    fill: "#f98525",
    stroke: "#061133",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 12.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    transform: "translate(2.956 2.246)",
    fill: "#f5f5f5",
    stroke: "#061133",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 7.5,
    rx: 0.75,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3085);
export default __webpack_public_path__ + "static/media/Group 3085.ecdf077452c84760498047b735ffe73d.svg";
export { ForwardRef as ReactComponent };